var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('el-card',[_c('el-row',[_c('div',{staticClass:"new-title"},[_vm._v("\n        "+_vm._s(_vm.form.newsTitle)+"\n      ")])]),_c('el-row',[_c('div',{staticClass:"new-text",domProps:{"innerHTML":_vm._s(_vm.form.newsText)}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }